import { formatEntityName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeSchemaCommentStmtInstruction = `
#### Remove comment from schema entity
- Syntax: \`remove comment <order> in <entity_name>;\`
- Example: \`remove comment 1 in Author;\`

Important notes:
- The comment is a string that describes the entity.
- The comment is used for documentation purposes.
- The comment is not used by the database engine.
`;
export const stmtRemoveSchemaComment = ({ order, entityName }) => {
    return `remove comment ${order} in ${entityName};`;
};
export const stmtForHumanRemoveSchemaComment = ({ order, entityName }) => {
    return `Remove the comment with order ${order} from the database table __${entityName}__.`;
};
export const removeSchemaCommentHandler = createSchemaStatementHandler({
    type: 'remove comment',
    parse: line => {
        const match = /^(remove|delete) comment (?<order>[\d]+) in (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove comment',
                order: Number.parseInt(match.groups.order),
                entityName: formatEntityName(match.groups.entityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRemoveSchemaComment,
    apply: (stmt, builder) => {
        builder.updateSchemaExtensions(it => {
            const comments = it.comments[stmt.entityName];
            if (!comments) {
                throw new Error(`No comments found for entity ${stmt.entityName}`);
            }
            if (stmt.order < 0 || stmt.order >= comments.length) {
                throw new Error(`Comment index out of bounds for entity ${stmt.entityName}`);
            }
            comments.splice(stmt.order, 1);
        });
    },
});
//# sourceMappingURL=RemoveCommentStmt.js.map